/**
 * Nidra Sleep Needs Quiz
 * Recreates Lovable SleepQuiz with zero personal data collection
 */
(function() {
  const QUESTIONS = [
    {
      q: "What are you hoping to improve?",
      options: [
        "Neck pain or stiffness",
        "Shoulder tension",
        "Waking up uncomfortable",
        "Trouble finding a comfortable position",
        "My current pillow doesn't feel right",
        "I simply want better sleep."
      ]
    },
    {
      q: "How often does this affect your sleep?",
      options: ["Regularly", "Sometimes", "Not really"]
    },
    {
      q: "How do you usually sleep?",
      options: ["Mostly back", "Mostly side", "Both side and back", "Mostly stomach", "Not sure"]
    }
  ];

  class QuizManager {
    constructor() {
      this.overlay = document.getElementById('SleepQuizOverlay');
      this.body = document.getElementById('SleepQuizBody');
      this.closeBtn = document.getElementById('SleepQuizClose');
      this.step = 0;
      this.answers = [];
      this.isOpen = false;

      this.initEvents();
    }

    initEvents() {
      // Listen to trigger buttons (e.g., from sleeper selector quiz card)
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('#TriggerSleepQuiz');
        if (trigger) {
          e.preventDefault();
          this.open();
        }
      });

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) this.close();
        });
      }

      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) this.close();
      });
    }

    open() {
      if (!this.overlay) return;
      this.step = 0;
      this.answers = [];
      this.isOpen = true;
      this.overlay.style.display = 'grid';
      document.body.style.overflow = 'hidden';
      this.render();
    }

    close() {
      if (!this.overlay) return;
      this.isOpen = false;
      this.overlay.style.display = 'none';
      document.body.style.overflow = '';
    }

    pick(option) {
      this.answers[this.step] = option;
      this.step++;
      this.render();
    }

    back() {
      if (this.step > 0) {
        this.step--;
        this.render();
      }
    }

    render() {
      if (!this.body) return;

      if (this.step < QUESTIONS.length) {
        const current = QUESTIONS[this.step];
        let optionsHtml = '';
        current.options.forEach(opt => {
          optionsHtml += `<button type="button" class="quiz-opt-btn" data-val="${opt}">${opt}</button>`;
        });

        this.body.innerHTML = `
          <p class="eyebrow">Sleep needs quiz &middot; ${this.step + 1} of ${QUESTIONS.length}</p>
          <h2>${current.q}</h2>
          <div class="quiz-options">
            ${optionsHtml}
          </div>
          ${this.step > 0 ? '<button type="button" class="quiz-back" id="QuizBackBtn">&larr; Back</button>' : ''}
          <p class="quiz-note">Anonymous. No email or personal details needed.</p>
        `;

        this.body.querySelectorAll('.quiz-opt-btn').forEach(btn => {
          btn.addEventListener('click', () => this.pick(btn.getAttribute('data-val')));
        });

        const backBtn = document.getElementById('QuizBackBtn');
        if (backBtn) {
          backBtn.addEventListener('click', () => this.back());
        }
      } else {
        // Result Screen
        const isStomach = this.answers[2] === 'Mostly stomach';

        if (isStomach) {
          this.body.innerHTML = `
            <p class="eyebrow">Your result</p>
            <h2>A fit consideration for stomach sleepers.</h2>
            <p class="quiz-body">Cervical contour pillows are sculpted primarily for back and side sleeping alignment. For dedicated stomach sleepers, a lower and flatter profile often provides a more natural resting position without arching the neck. If you switch between stomach and side, our lower Compact contour may be suitable.</p>
            <a href="/products/nidra-cervical-memory-foam-pillow" class="btn" style="margin-top: 24px;" id="QuizResultCta">
              Explore Compact Profile &rarr;
            </a>
          `;
        } else {
          this.body.innerHTML = `
            <p class="eyebrow">Your result</p>
            <h2>Your sleep may benefit from better cervical support.</h2>
            <p class="quiz-body">Nidra is designed with a dual-height cervical contour to support a more comfortable sleeping position.</p>
            <span class="quiz-badge">Special savings on prepaid orders</span>
            <br>
            <a href="/products/nidra-cervical-memory-foam-pillow" class="btn" style="margin-top: 24px;" id="QuizResultCta">
              Shop Nidra &rarr;
            </a>
          `;
        }

        const resultCta = document.getElementById('QuizResultCta');
        if (resultCta) {
          resultCta.addEventListener('click', () => this.close());
        }
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    window.NidraQuiz = new QuizManager();
  });
})();
